'use client'

import { css, cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import type { SomethingWentWrongDSProps } from './something-went-wrong-ds.types'

// Parity with legacy `.graceful_error_message_wrapper` (somethingWentWrong.module.scss).
const errorWrapperClass = css({ textAlign: 'center' })

// Parity with legacy `.graceful_error_message_content`: `margin: 1.2rem 0` / `font-size: 1.5rem` /
// `line-height: 2rem`. Those rem values resolve against the legacy fluid ~10px root
// (quince-styles/scss/normalize.scss), i.e. ~12px / ~15px / ~20px — they must NOT be carried over as
// rem, since the DS branch keeps the browser's 16px root and would render them ~1.6x too large.
// `space-12` is exactly 12px. 15px has no text token: `body-14` is 14px/20px, matching legacy's
// line-height exactly and its font-size within 1px (`body-16` is 16px/22px, further off on both).
const errorContentClass = css({ my: 'space-12', textStyle: 'body-14' })

/**
 * Design-system error state. Prop-driven and caller-agnostic — no PL / widget imports, so any
 * surface can render it.
 */
export function SomethingWentWrongDS({ show = true, minHeight, wrapperClass }: SomethingWentWrongDSProps) {
  const { t } = useTranslation('accountPage')

  if (!show) return null

  return (
    <div className={cx(errorWrapperClass, wrapperClass)} style={{ minHeight }}>
      <div className={errorContentClass}>
        {t('somethingWentWrong')}
        <br />
        {t('refreshPage')}
      </div>
    </div>
  )
}
